import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardCardsComponent } from './components/dashboard-cards/dashboard-cards.component';
import { DashboardFilterCardComponent } from './components/dashboard-filter-card/dashboard-filter-card.component';
import { LTNavigationCardComponent } from './components/lt-navigation-card/lt-navigation-card.component';
import { LtScrollCardsComponent } from './components/lt-scroll-cards/lt-scroll-cards.component';
import { LTSearchCardComponent } from './components/lt-search-card/lt-search-card';
@NgModule({
  imports: [
    CommonModule,
    DashboardCardsComponent,
    DashboardFilterCardComponent,
    LTNavigationCardComponent,
    LtScrollCardsComponent,
    LTSearchCardComponent,
  ],
  exports: [
    DashboardCardsComponent,
    DashboardFilterCardComponent,
    LTNavigationCardComponent,
    LtScrollCardsComponent,
    LTSearchCardComponent,
  ],
})
export class LTCardModule { }